export default __webpack_public_path__ + "static/media/complete_course.28dec77c.png";